<template>
  <div class="personal-center">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>个人中心</span>
        </div>
      </template>
      
      <div class="user-info">
        <div class="info-item">
          <div class="info-label">管理员名称：</div>
          <div class="info-value">{{ userInfo.username }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">账号名：</div>
          <div class="info-value">{{ userInfo.username }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">密码：</div>
          <div class="info-value">{{ maskedPassword }}</div>
          <el-button type="primary" size="small" @click="showChangePasswordDialog">修改密码</el-button>
        </div>
        <div class="info-item">
          <div class="info-label">管理权限：</div>
          <div class="info-value permissions">
            <el-tag 
              v-for="permission in userInfo.permissions" 
              :key="permission"
              size="small"
              style="margin-right: 5px; margin-bottom: 5px;">
              {{ permission }}
            </el-tag>
          </div>
        </div>
        <div class="info-item">
          <div class="info-label">登录时间：</div>
          <div class="info-value">{{ formatLoginTime }}</div>
        </div>
      </div>
    </el-card>
    
    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="changePasswordDialogVisible" width="400px">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="changePassword">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PersonalCenter',
  data() {
    return {
      userInfo: {},
      changePasswordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    maskedPassword() {
      return '********';
    },
    formatLoginTime() {
      if (this.userInfo.loginTime) {
        const date = new Date(this.userInfo.loginTime);
        return date.toLocaleString();
      }
      return '';
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr);
      }
    },
    showChangePasswordDialog() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.changePasswordDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.passwordForm && this.$refs.passwordForm.clearValidate();
      });
    },
    changePassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          if (this.passwordForm.oldPassword === '@Mjw20060623') {
            this.$message.success('密码修改成功！');
            this.changePasswordDialogVisible = false;
          } else {
            this.$message.error('原密码错误！');
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.personal-center {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-info {
  margin-top: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.info-label {
  width: 120px;
  font-weight: bold;
  color: #333;
}

.info-value {
  flex: 1;
  color: #666;
}

.permissions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.info-item button {
  margin-left: 20px;
}
</style>
